// extracted by mini-css-extract-plugin
export var completionBody = "_jp-2";
export var completionCard = "_jp-0";
export var completionFooter = "_jp-3";
export var completionTitle = "_jp-1";